module.exports = __webpack_public_path__ + "static/media/C20-0696_250MamaSmile_Mobile_767x845_FR.b08a7e45.jpg";